import { black, blue, brown, caribbeanBlue, darkGrey, lightBlue, lilac } from '../const/colors'
import { BRAND_PRIMARY_COLOR, BRAND_PRIMARY_LIGHT_COLOR } from '../../helpers/other'
import { isColorDark } from '../helpers'
import { text_muted } from '../const/newColors'

// graph colors
export const DEFAULT_GRAPH_COLOR = 'defaultGraphColor'
export const GRAPH_COLOR_1 = 'graphColor1'
export const GRAPH_COLOR_2 = 'graphColor2'
export const GRAPH_COLOR_3 = 'graphColor3'

// menu bar colors
export const MENU_BAR = 'menuBar'
export const MENU_BAR_ACCOUNT_NAME = 'menuBarAccountName'
export const MENU_BAR_ACCOUNT_LABEL = 'menuBarAccountLabel'
export const MENU_BAR_INFO_USER_NAME = 'menuBarInfoUserName'
export const MENU_BAR_INFO_ACCOUNT_NAME = 'menuBarInfoAccountName'
export const MENU_BAR_LIST_LINK = 'menuBarListLink'
export const MENU_BAR_LIST_LINK_ACTIVE = 'menuBarListLinkActive'
export const MENU_BAR_LIST_LINK_CONTENT = 'menuBarListLinkContent'
export const MENU_BAR_ICON = 'menuBarIcon'

// select
export const SELECT_OPTION_FOCUSED_COLOR = 'selectOptionFocusedColor'

export type ThemeColors = Record<string, string | undefined>

export interface DefaultTheme {
  textMuted: string
  brandPrimary: string
  brandPrimaryLight: string
  brandPrimaryTextContrastColor: string
  fontFamily: {
    name: string
    value: string
    normal?: string
    medium?: string
    bold?: string
    format?: string
  }
  [MENU_BAR]: {
    backgroundColor: string
  }
  [MENU_BAR_ACCOUNT_NAME]: {
    color: string
    fontSize?: string
  }
  [MENU_BAR_ACCOUNT_LABEL]: {
    color: string
  }
  [MENU_BAR_INFO_USER_NAME]: {
    color: string
  }
  [MENU_BAR_INFO_ACCOUNT_NAME]: {
    color: string
  }
  [MENU_BAR_LIST_LINK]: {
    color: string
    fontSize: string
    fontWeight: string
    backgroundColor: string
  }
  [MENU_BAR_LIST_LINK_ACTIVE]: {
    color: string
  }
  [MENU_BAR_LIST_LINK_CONTENT]: {
    padding: string
    minHeight?: string
  }
  [MENU_BAR_ICON]: {
    color: string
  }
  [DEFAULT_GRAPH_COLOR]: string
  [GRAPH_COLOR_1]: string
  [GRAPH_COLOR_2]: string
  [GRAPH_COLOR_3]: string
  [SELECT_OPTION_FOCUSED_COLOR]: string
}

const defaultBrandPrimary = blue
const defaultBrandPrimaryLight = lightBlue

export const getDefaultTheme = (colors: ThemeColors, isNewStylesThemeEnabled: boolean): DefaultTheme => {
  const brandPrimary = colors?.[BRAND_PRIMARY_COLOR] ? `#${colors[BRAND_PRIMARY_COLOR]}` : defaultBrandPrimary
  const brandPrimaryLight = colors?.[BRAND_PRIMARY_LIGHT_COLOR]
    ? `#${colors[BRAND_PRIMARY_LIGHT_COLOR]}`
    : defaultBrandPrimaryLight

  const isBrandPrimaryDark = isColorDark(brandPrimary)

  return {
    textMuted: isNewStylesThemeEnabled ? text_muted : '#000000',
    brandPrimary,
    brandPrimaryLight,
    brandPrimaryTextContrastColor: isBrandPrimaryDark ? '#FFFFFF' : black,
    fontFamily: {
      name: 'Lato',
      value: `'Lato', sans-serif`
    },
    // menu bar colors
    [MENU_BAR]: {
      backgroundColor: '#FFFFFF'
    },
    [MENU_BAR_ACCOUNT_NAME]: {
      color: '#000000'
    },
    [MENU_BAR_ACCOUNT_LABEL]: {
      color: '#777777'
    },
    [MENU_BAR_INFO_USER_NAME]: {
      color: '#3D3D3D'
    },
    [MENU_BAR_INFO_ACCOUNT_NAME]: {
      color: '#777777'
    },
    [MENU_BAR_LIST_LINK]: {
      color: darkGrey,
      fontSize: '14px',
      fontWeight: '500',
      backgroundColor: brandPrimaryLight
    },
    [MENU_BAR_LIST_LINK_ACTIVE]: {
      color: brandPrimary
    },
    [MENU_BAR_LIST_LINK_CONTENT]: {
      padding: '8px'
    },
    [MENU_BAR_ICON]: {
      color: darkGrey
    },
    // graph colors
    [DEFAULT_GRAPH_COLOR]: brandPrimary,
    [GRAPH_COLOR_1]: brown,
    [GRAPH_COLOR_2]: caribbeanBlue,
    [GRAPH_COLOR_3]: lilac,
    // select colors
    [SELECT_OPTION_FOCUSED_COLOR]: brandPrimary
  }
}
